import React from 'react'

import { array, string } from 'prop-types'

import CategoryCard from './CategoryCard'

function CategoryList({ categories, locale }) {
  return (
    <div className="categories-section__categories-list">
      {categories?.map((category) => (
        <CategoryCard key={`${category.slug}-${locale}`} category={category} locale={locale} />
      ))}
    </div>
  )
}

CategoryList.propTypes = {
  categories: array.isRequired,
  locale: string.isRequired,
}

export default CategoryList
